export default {
  editorTitle: 18, // primary code
  // new add by liugezhou
  loginType: localStorage.getItem('login_type') || '',
  activityInfo: JSON.parse(localStorage.getItem('activityInfo')) || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || '',
  activityId: localStorage.getItem('activity_id') || '',
  playerInfo: JSON.parse(localStorage.getItem('player_info')) || ''
}



// WEBPACK FOOTER //
// ./src/store/state.js